<template>
  <b-sidebar :id="'sidebar-import-recording-import'" :title="'Sesión a la que se importa: ' + classroomOrigin.name"
  sidebar-class="bb-offcanvas-panel b-sidebar-recording"
  v-on:shown="initRecordingImport(recordingImport)"
  bg-variant="white" right backdrop-variant="dark" backdrop shadow>
    <template #default="{ hide }">
      <div class="row form-row" :class="{ 'form-group--error': $v.name.$error }">
        <label class="column col-sm-12 ng-scope form__label">Nombre de la grabación</label>
        <b-form-input :id="'recording-name-' + recordingImport.id" type="text" v-model="name" maxlength="255"></b-form-input>
      </div>
      <div class="error" v-if="!$v.name.required">El nombre es obligatorio (al menos 4 caracteres)</div>
      <div class="row form-row">
        <label class="column col-sm-12 ng-scope" bb-translate="" analytics-id="session.update.date.start-label">Inicio</label>
        <div class="picker-input date column col-sm-6">
          <b-form-datepicker
            today-button
            label-today-button="Hoy"
            label-help="Usa las flechas del teclado para navegar entre fechas"
            label-no-date-selected="-"
            :id="'recording-start-date-' + recordingImport.id" type="text"
            v-model="start_date"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="es">
          </b-form-datepicker>
        </div>
        <div class="picker-input column col-sm-6">
          <b-form-timepicker
            label-close-button="Cerrar"
            label-no-time-selected="-"
            :id="'recording-start-time-' + recordingImport.id" type="text"
            v-model="start_time"
            locale="es">
          </b-form-timepicker>
        </div>
      </div>
      <div class="row form-row">
        <label class="column col-sm-12 ng-scope" bb-translate="" analytics-id="session.update.date.start-label">Fin</label>
        <div class="picker-input date column col-sm-6">
          <b-form-datepicker
            today-button
            label-today-button="Hoy"
            label-help="Usa las flechas del teclado para navegar entre fechas"
            label-no-date-selected="-"
            :id="'recording-end-date-' + recordingImport.id" type="text"
            v-model="end_date"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="es">
          </b-form-datepicker>
        </div>
        <div class="picker-input column col-sm-6">
          <b-form-timepicker
            label-close-button="Cerrar"
            label-no-time-selected="-"
            :id="'recording-end-time-' + recordingImport.id" type="text"
            v-model="end_time"
            locale="es">
          </b-form-timepicker>
        </div>
      </div>
    </template>
    <template #footer="{ hide }">
      <div class="save-buttons panel-footer">
        <div class="buttons-2 equal-buttons row">
          <div class="col-sm-6">
            <button class="button secondary cancel-button" @click="hide">Cancelar</button>
          </div>
          <div class="col-sm-6">
            <button class="button save-button" @click="updateRecording">Guardar</button>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import LocationEnterIcon from 'vue-material-design-icons/LocationEnter.vue'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import { minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'ImportRecordingImportSidebar',
  components: {CloseIcon, LocationEnterIcon},
  mixins: [utilitiesMixin],
  props: ['recordingImport', 'classroomOrigin', 'reuseClassroom'],
  mounted () {
    this.$moment.locale('es')
  },
  data () {
    return {
      loading: false,
      name: null,
      start_date: null,
      start_time: null,
      end_date: null,
      end_time: null
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    }
  },
  methods: {
    initRecordingImport (recordingImport) {
      let now = window.moment()
      this.name = recordingImport.name
      this.start_date = this.recordingImport ? window.moment(this.recordingImport.startTime).format('YYYY-MM-DD') : now.format('YYYY-MM-DD')
      this.start_time = this.recordingImport ? window.moment(this.recordingImport.startTime).format('HH:mm') : now.format('HH:mm')
      now = now.add(1, 'hours')
      this.end_date = this.recordingImport ? window.moment(this.recordingImport.endTime).format('YYYY-MM-DD') : now.format('YYYY-MM-DD')
      this.end_time = this.recordingImport ? window.moment(this.recordingImport.endTime).format('HH:mm') : now.format('HH:mm')
    },
    updateRecording () {
      let vueComponent = this

      // Validación previa al envío de formulario
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      // Se importa la grabación
      let recording = {
        name: this.name,
        startTime: window.moment(this.start_date + ' ' + this.start_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        endTime: window.moment(this.end_date + ' ' + this.end_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      }

      window.axios.put('recordings/' + this.classroomOrigin.id + '/' + this.recordingImport.id, recording)
      // Se reinicia el modelo y la validación, se oculta el modal y se recarga la lista
      Object.assign(this.$data, this.$options.data.call(this))
      vueComponent.$v.$reset()
      this.$root.$emit('bv::toggle::collapse', 'sidebar-import-recording-import')
      this.$root.$emit('bv::toggle::collapse', 'sidebar-import-recording-sesion-' + this.reuseClassroom.id)
      this.$root.$emit('bv::toggle::collapse', 'sidebar-import-recording-' + this.classroomOrigin.id)
      this.$root.$emit('bv::toggle::collapse', 'sidebar-recordings-' + this.classroomOrigin.id)

      vueComponent.$noty.success('La grabación se ha importado a la sesión solicitada.', {
        timeout: 3000,
        progressBar: true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Modals/ImportRecordingImportSidebar.vue